export enum SupabaseFilterOperator {
	Equal = '=',
	NotEqual = '!=',
	LessThan = '<',
	LessThanOrEqual = '<=',
	GreaterThan = '>',
	GreaterThanOrEqual = '>=',
	Like = 'LIKE',
	In = 'IN',
	NotIn = 'NOT IN',
}
